import { useStore } from '../../../store';

const store = useStore();

export const resetNews = () => {
    store.commit('press/SET_PAGE_NUMBER', 1);
    store.commit('press/SET_NEWS', []);
}
